export default __webpack_public_path__ + "static/media/add comments.45b2ec03.svg";